module.exports = __webpack_public_path__ + "img/home.082c4d7c.svg";